import { render, staticRenderFns } from "./PageBase.vue?vue&type=template&id=e3a9cbe2&scoped=true"
import script from "./PageBase.vue?vue&type=script&lang=ts"
export * from "./PageBase.vue?vue&type=script&lang=ts"
import style0 from "./PageBase.vue?vue&type=style&index=0&id=e3a9cbe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a9cbe2",
  null
  
)

export default component.exports